module.exports = __webpack_public_path__ + "static/media/finternet-button-mobile.89acb08e.svg";